// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions} from '../duck';
import NewCheckoutInput from '../checkout-config/NewCheckoutInput';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(NewCheckoutInput);
